import React from 'react'
import { withRouter } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faExclamationCircle,
	faCheckCircle,
	faExclamationTriangle,
	faBomb
} from '@fortawesome/free-solid-svg-icons'
import { FormattedMessage } from 'react-intl'
import { Colors } from '../../components/Styles'
import { Alert } from 'antd'

const messageConfig = {
	ALREADY_PAIRED_SUCCESS: {
		icon: faCheckCircle,
		iconColor: Colors.status.green.color,
		timeout: 5_000
	},
	FIRST_PAIRING_SUCCESS: {
		icon: faCheckCircle,
		iconColor: Colors.status.green.color,
		timeout: 10_000
	},
	THIRD_PARTY_DEVICES_NOT_ENABLED_ERROR: {
		icon: faExclamationTriangle,
		iconColor: Colors.status.red.color,
		timeout: 10_000
	},
	MAX_DEVICES_REACHED_ERROR: {
		icon: faExclamationTriangle,
		iconColor: Colors.status.red.color,
		timeout: 10_000
	},
	UNKNOWN_ERROR: {
		icon: faBomb,
		iconColor: Colors.status.red.color,
		timeout: 10_000
	}
}

class SonosPairingResult extends React.Component {
	constructor(props) {
		super(props)
		this.state = this.getStateFromProps(this.props)
	}

	getStateFromProps(props) {
		const { match } = props
		let code
		if (match) {
			code = match.params.code
		}

		// ensure we have an expected result code, if not we consider it as an unknown error
		if (!code || !messageConfig[code]) {
			code = 'UNKNOWN_ERROR'
		}
		const config = messageConfig[code]
		const messageId = `thirdPartyDevices.sonos.pairingResult.${code}`

		return {
			config,
			messageId,
			callbackPath:
				new URLSearchParams(this.props.location.search).get(
					'callbackPath'
				) ?? 'sonos://'
		}
	}

	componentDidMount() {
		setTimeout(() => {
			console.log(
				'Redirecting to Sonos app with callback path:',
				this.state.callbackPath
			)
			window.location.replace(this.state.callbackPath)
		}, this.state.config.timeout)
	}

	render() {
		const { config, messageId } = this.state
		let content = (
			<div style={styles.container}>
				<FontAwesomeIcon
					icon={config.icon}
					style={{
						fontSize: 150,
						color: config.iconColor,
						margin: 20
					}}
				/>
				<h3
					style={{
						textAlign: 'center',
						whiteSpace: 'pre-line',
						margin: 20
					}}
				>
					<FormattedMessage
						id={messageId}
						values={{
							warning: (chunks) => (
								<Alert
									style={{ textAlign: 'left', margin: 20 }}
									type="warning"
									showIcon
									description={chunks}
								/>
							)
						}}
					/>
				</h3>
			</div>
		)

		return content
	}
}

export default withRouter(SonosPairingResult)

const styles = {
	container: {
		width: '100%',
		minHeight: 400,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	}
}
